var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8481 13.5C11.6325 13.5 11.417 13.4206 11.2468 13.2505C10.9177 12.9215 10.9177 12.377 11.2468 12.0481L20.5505 2.74671C20.8796 2.41776 21.4242 2.41776 21.7532 2.74671C22.0823 3.07566 22.0823 3.62013 21.7532 3.94908L12.4495 13.2505C12.2793 13.4206 12.0637 13.5 11.8481 13.5Z",
    fill: "#000ED0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0476 9.5C21.527 9.5 21.0952 9.06825 21.0952 8.54762V3.40476H15.9524C15.4317 3.40476 15 2.97302 15 2.45238C15 1.93175 15.4317 1.5 15.9524 1.5H22.0476C22.5683 1.5 23 1.93175 23 2.45238V8.54762C23 9.06825 22.5683 9.5 22.0476 9.5Z",
    fill: "#000ED0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3488 24.5H8.65116C2.58977 24.5 0 21.9102 0 15.8488V9.15116C0 3.08977 2.58977 0.5 8.65116 0.5H10.8837C11.3414 0.5 11.7209 0.879535 11.7209 1.33721C11.7209 1.79488 11.3414 2.17442 10.8837 2.17442H8.65116C3.50512 2.17442 1.67442 4.00512 1.67442 9.15116V15.8488C1.67442 20.9949 3.50512 22.8256 8.65116 22.8256H15.3488C20.4949 22.8256 22.3256 20.9949 22.3256 15.8488V13.6163C22.3256 13.1586 22.7051 12.7791 23.1628 12.7791C23.6205 12.7791 24 13.1586 24 13.6163V15.8488C24 21.9102 21.4102 24.5 15.3488 24.5Z",
    fill: "#000ED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.b87d45db249c11b82c0da49e6bcd0608.svg";
export { ForwardRef as ReactComponent };